// types/blockchain-sports.ts
import { Group } from "../group.model";

// Enums (string enums to match Prisma enum values)
export enum RewardType {
  DIGITAL = "DIGITAL",
  RWA = "RWA",
}

export enum BlockchainSportsInstrument {
  USD = "USD",
  USDC = "USDC",
  USDT = "USDT",
  ATLA = "ATLA",
}

// Main models
export interface BlockchainSports {
  id: number;

  quantity?: number;
  node?: number;
  dataStorageNode?: number;

  group_id?: number;
  group?: Group | null;

  BlockchainSportsReward: BlockchainSportsReward[];
}

export interface BlockchainSportsReward {
  id: number;
  instrumentType: BlockchainSportsInstrument;
  amount?: number;
  rewardType: RewardType;

  blockchainSportsId?: number | null;
  blockchainSports?: BlockchainSports | null;
}
